module.exports = __webpack_public_path__ + "static/media/frame.9be82baf.svg";